/* eslint-disable react/prop-types */

const produceFilterModel = (totals) => {
  return [
    {
      groupLabel: 'Status',
      filters: [
        {
          label: 'Overdue',
          key: 'status',
          value: 'overdue',
          badge: 'red',
          count: totals ? totals.status.overdue : null,
          filterFunction: (item) => item.status === 'overdue',
        },
        {
          label: 'Open',
          key: 'status',
          value: 'open',
          badge: 'amber',
          count: totals ? totals.status.open : null,
          filterFunction: (item) => item.status === 'open',
        },
        {
          label: 'Resolved',
          key: 'status',
          value: 'resolved',
          badge: 'green',
          count: totals ? totals.status.resolved : null,
          filterFunction: (item) => item.status === 'resolved',
        },
        {
          label: 'Draft',
          key: 'status',
          value: 'draft',
          badge: 'grey',
          count: totals ? totals.status.draft : null,
          filterFunction: (item) => item.status === 'draft',
        },
      ],
    },
    {
      groupLabel: 'Type',
      filters: [
        {
          label: 'CAS',
          key: 'type',
          value: 'CAS',
          count: totals ? totals.type.cas : null,
          filterFunction: (item) => item.display_data.type === 'CAS',
        },
        {
          label: 'CDL',
          key: 'type',
          value: 'CDL',
          count: totals ? totals.type.cdl : null,
          filterFunction: (item) => item.display_data.type === 'CDL',
        },
        {
          label: 'MEL',
          key: 'type',
          value: 'MEL',
          count: totals ? totals.type.mel : null,
          filterFunction: (item) => item.display_data.type === 'MEL',
        },
        {
          label: 'NEF',
          key: 'type',
          value: 'NEF',
          count: totals ? totals.type.nef : null,
          filterFunction: (item) => item.display_data.type === 'NEF',
        },
        {
          label: 'Other',
          key: 'type',
          value: 'Other',
          count: totals ? totals.type.other : null,
          filterFunction: (item) => item.display_data.type === 'Other' || null,
        },
      ],
    },
    {
      groupLabel: 'Deferred',
      filters: [
        {
          label: 'Deferred',
          key: 'deferred',
          value: true,
          count: totals ? totals.deferred.deferred : null,
          filterFunction: (item) => item.deferred === true,
        },
        {
          label: 'Non-deferred',
          key: 'deferred',
          value: false,
          count: totals ? totals.deferred.non_deferred : null,
          filterFunction: (item) => item.deferred === false,
        },
      ],
    },
  ];
};

export default produceFilterModel;

// {
//   groupLabel: 'Custom Component',
//   contents: [
//     {
//       type: 'custom-component',
//       label: 'Custom Defect Filter',
//       key: 'workpack_items',
//       nestedArraySubKey: 'mx_item',
//       compareCallback(value, currItem) {
//         return value === true && currItem && currItem.name && currItem.name === '600HR Check';
//       },
//       customComponent({
//         toggleFilterItem: { label, key, relatedTo, count, compareCallback, nestedArraySubKey },
//         updateExclusiveFilter,
//         filterStates,
//       }) {
//         const checked = (filterStates.workpack_items && filterStates.workpack_items.filterState) || false;

//         const handlestageFilterState = () => {
//           updateExclusiveFilter({
//             key,
//             type: 'exclusive-key-filter',
//             filterState: !checked,
//             relatedTo,
//             compareCallback,
//             nestedArraySubKey,
//           });
//         };

//         return (
//           <div>
//             <label htmlFor="custom-filter">
//               {label} <span>({count})</span>
//             </label>
//             <input
//               id="custom-filter"
//               className={styles.filterInput}
//               type="checkbox"
//               checked={checked}
//               onChange={handlestageFilterState}
//             />
//           </div>
//         );
//       },
//       count: draft,
//     },
//   ],
// },
